<div class="success-container">
  <div class="success-visual">
    <div class="custom-icon success_lrg"></div>
  </div>

  @if (!order) {
    <div class="success-text">
      <h1>Ticket Submitted!</h1>
      <p class="font-lato font-medium">
        Your ticket has been created and sent. We will keep you updated on the
        status of your ticket as we proceed. If you created a disconnect ticket,
        check the orders page for updates.
      </p>

      <div class="mt-6 flex w-full justify-center">
        <button class="btn-primary min-w-12" (click)="onClosed()">OK</button>
      </div>
    </div>
  } @else {
    <div class="success-text">
      <h1>Order Submitted!</h1>
      @if (order.Id) {
        <h2>
          Your order
          <a routerLink="/orders/{{ order.Id }}" (click)="onClosed()">
            {{ order.Name }}</a
          >
          has been created and sent. We will keep you updated on the status of
          your order as we proceed.
        </h2>
      } @else {
        <h2>
          Your <a routerLink="/orders" (click)="onClosed()">order</a> has been
          created and sent. We will keep you updated on the status of your order
          as we proceed.
        </h2>
      }
      <div class="mt-6 flex w-full justify-center">
        <button class="btn-primary min-w-12" (click)="onClosed()">OK</button>
      </div>
    </div>
  }
</div>
